var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconKo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 15,
    height: 15,
    rx: 2,
    fill: "#757CA1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8754 13.283H12.0124V12.381H14.3774V11.237H15.5104V12.381H17.8754V13.283ZM21.1644 14.416V15.351H19.7564V18.695H18.6234V11.248H19.7564V14.416H21.1644ZM17.3474 15.626C17.3474 16.77 16.3684 17.507 14.9384 17.507C13.5194 17.507 12.5294 16.77 12.5294 15.626C12.5294 14.515 13.5194 13.745 14.9384 13.745C16.3684 13.745 17.3474 14.515 17.3474 15.626ZM13.6184 15.626C13.6184 16.253 14.1464 16.627 14.9384 16.627C15.7304 16.627 16.2694 16.253 16.2694 15.626C16.2694 14.999 15.7304 14.625 14.9384 14.625C14.1464 14.625 13.6184 14.999 13.6184 15.626ZM14.6084 20.07H20.1524V20.994H13.4644V18.123H14.6084V20.07Z",
    fill: "#011136"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKo);
export default __webpack_public_path__ + "static/media/Icon_Ko.119180707fb5e449fc1669ec9b5b073b.svg";
export { ForwardRef as ReactComponent };